import { Flex, Box, Text } from '@cad-arc';
import { UseFormReturn, useWatch } from 'react-hook-form';
import { FormCheckbox } from '../forms/integrated-form-controls/form-checkbox';
import { SearchFormFooter } from '../search-windows/search-form-footer';
import { UnitStatusSearchFormType } from './types';
import { isFormValid } from './utils';

export function UnitStatusSearchFormFooter({
    form,
}: {
    form: UseFormReturn<UnitStatusSearchFormType>;
}) {
    const formValues = useWatch({ control: form.control });
    const isValid = isFormValid(formValues);
    return (
        <SearchFormFooter isFormValid={isValid} onClearAllFields={() => form.reset()}>
            <Flex alignItems="center" flexWrap="nowrap" gap={8}>
                <Flex gap={2} alignItems="center">
                    <Box>
                    <FormCheckbox
                        name="fuzzyMatchingEnabled"
                        label="Enable Fuzzy Matching"
                        control={form.control}
                    />
                    </Box>
                    <Text
                        variant="caption"
                        color="tertiary"
                    >
                        (May slow search speed)
                    </Text>
                </Flex>
            </Flex>
        </SearchFormFooter>
    );
}
